import React, { useEffect, useState } from "react";

import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CForm,
  CInput,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CRow
} from "@coreui/react";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";

import logo from "../../assets/imgs/logo_original.png";
import Loading from "../../components/Loading";
import URL from "../../config/api";
import axios from "../../config/axios";

const ForgotPassword = props => {
  const { email, token } = props.match.params;
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [password, setPassword] = useState("");

  useEffect(() => {
    setLoading(false);
  }, []);

  const changePasswordFunction = e => {
    setLoading(true);
    e.preventDefault();
    let obj = {
      email: decodeURIComponent(email),
      token,
      password
    };
    axios
      .post(`${URL.api}changePassword`, obj)
      .then(response => {
        if (response.data.data === "Senha atualizada com sucesso.") {
          toastr.success(
            "Sucesso",
            `${response.data.data} Pode realizar o login normalmente agora.`
          );
          history.push("/");
        }
        setLoading(false);
      })
      .catch(response => {
        setLoading(false);
      });
  };

  return (
    <>
      {loading ? (
        <div className="c-app c-default-layout flex-row align-items-center">
          <Loading />
        </div>
      ) : (
        <div className="c-app c-default-layout flex-row align-items-center">
          <CContainer>
            <CRow className="justify-content-center">
              <CCol xs="12" sm="9" md="7" lg="5" xl="5">
                <CCard className="p-4">
                  <CCardBody>
                    <div className="d-flex justify-content-start mb-4">
                      <img src={logo} alt="logo da empresa" />
                    </div>
                    <h1>Redefinição de senha</h1>
                    <p className="text-muted">
                      Preencha o campo abaixo para realizar o cadastro da nova
                      senha.
                    </p>
                    <CForm onSubmit={changePasswordFunction}>
                      <CInputGroup className="mb-3">
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i
                              className="fa fa-envelope"
                              style={{ width: 14 }}
                            ></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <CInput
                          type="text"
                          value={decodeURIComponent(email)}
                          autoComplete="username"
                          disabled
                        />
                      </CInputGroup>
                      <CInputGroup className="mb-3">
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-lock" style={{ width: 14 }}></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <CInput
                          type="password"
                          value={password}
                          placeholder="Digite a nova senha"
                          autoComplete="current-password"
                          onChange={e => setPassword(e.target.value)}
                        />
                      </CInputGroup>
                      <CButton type="submit" color="primary" block>
                        Trocar senha
                      </CButton>
                    </CForm>
                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>
          </CContainer>
        </div>
      )}
    </>
  );
};

export default ForgotPassword;
